// extracted by mini-css-extract-plugin
export default {"profileItem":"style_profileItem__+eBlT","profileItemContent":"style_profileItemContent__WdyE7","profileText":"style_profileText__Z1y9m","rowSuspended":"style_rowSuspended__3Y4iA"};